import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { removeToolbox } from 'store/AddWidget/actions'

function RemovableWidgetDiv({ id, toolboxes, layouts, toolbox }) {
  const dispatch = useDispatch()
  const [hover, setHover] = useState(false)

  const filterManagerAlert = (arr) =>
    arr && arr.filter((item) => item.i !== toolbox.id)

  return (
    <>
      <div
        role='button'
        onClick={() => {
          dispatch(
            removeToolbox(
              id,
              toolboxes.filter((tool) => tool.id !== toolbox.id),
              {
                lg: filterManagerAlert(layouts.lg),
                md: filterManagerAlert(layouts.md),
                sm: filterManagerAlert(layouts.sm),
              }
            )
          )
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className={`${
          hover ? 'bg-danger text-white' : 'bg-secondary text-black'
        } border rounded-sm shadow-sm p-3 my-2 d-flex align-items-center justify-content-center position-relative`}
        style={{ height: '50px', transition: 'color 0.3s ease-in-out' }}
      >
        <span
          style={{
            opacity: hover ? 0 : 1,
          }}
        >
          {toolbox.name}
        </span>
        <FontAwesomeIcon
          icon={faTrash}
          className='position-absolute'
          style={{
            opacity: hover ? 1 : 0,
          }}
        />
      </div>
    </>
  )
}

export default RemovableWidgetDiv
